import { FC, PropsWithChildren } from 'react';

import type { PostHogConfig } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

import { isImpersonating, registerBaseProperties } from '@/lib/analytics/client';
import { analyticsEnabled } from '@/lib/analytics/config';

const POSTHOG_OPTIONS: Partial<PostHogConfig> = {
	api_host: 'https://stats-eu.vadio.no',
	ui_host: 'https://eu.posthog.com',
	capture_pageview: 'history_change',
	capture_pageleave: 'if_capture_pageview',
	person_profiles: 'identified_only',
	disable_session_recording: false,
	session_recording: { maskAllInputs: true, maskTextSelector: '[data-ph-mask]' },
	loaded: (client) => {
		registerBaseProperties(client);
		if (isImpersonating()) client.opt_out_capturing();
	},
};

export const PostHog: FC<PropsWithChildren> = ({ children }) => {
	if (!analyticsEnabled) {
		return children;
	}

	return (
		<PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={POSTHOG_OPTIONS}>
			{children}
		</PostHogProvider>
	);
};
